/**
 * API client for clinical admin session management.
 */
/**
 * Fetches the status of a specific session from the clinical admin backend.
 *
 * @param {string} roomName - The Jitsi room name (e.g., "session-927f96c7").
 * @param {string} backendUrl - The base URL of the clinical admin backend.
 * @returns {Promise<SessionStatusResponse>} - The session data.
 * @throws {Error} - If the fetch fails or returns an error status.
 */
export async function fetchSessionStatus(roomName, backendUrl) {
    const url = `${backendUrl}/sessions/by-room/${roomName}/status`;
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            // No authentication required - public endpoint for session status checks
            credentials: 'omit'
        });
        if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        const data = await response.json();
        return data;
    }
    catch (error) {
        console.error('[session-management] Failed to fetch session status:', error);
        throw error;
    }
}
